import { inject, observer } from 'mobx-react';
import { pushToTicketDetail } from '../../liveRouting';
import * as stores from '../../liveStores';
import { TicketListContainerBase } from './ticketListContainerBase';
import { TicketListStateFilterModel } from 'eTip--common';

@inject(stores.ApplicationStoreKey)
@observer
export class LiveTicketWinListContainer extends TicketListContainerBase {

    // copy from LiveTicketListContainer as can't inherit from observered class

    canShowPotentialWin = true;

    componentWillMount() {
        (this.props.applicationStore as any).setCanShowLeftColumn(true);
        this.store.resetFilter(TicketListStateFilterModel.Win);
        super.componentWillMount();
    }

    get store() {
        return this.props.applicationStore.ticketList;
    }

    goToDetail(ticketId: string) {
        pushToTicketDetail(ticketId);
    }
}